export default (props) => {
	switch (props.decorator || props.is) {
		case 'WebLayout':
			return import('./components/WebLayout');
		case 'RadioSelect':
		case 'CheckboxSelect':
			return import('fg-frontend/src/components/RadioSelect');
		case 'AddSvgIconSprite':
			return import('./components/AddSvgIconSprite');
		case 'Typeahead':
			return import('./components/Typeahead');
		case 'SelectDesign':
			return import('./components/SelectDesign');
		case 'NumberInput':
			return import('fg-frontend/components/NumberInput');
		case 'Tooltip':
			return import('./components/Tooltip');
		case 'Toggler':
			return import('./components/Toggler');
		case 'GtmMHubHandler':
			return import('./components/GtmMHubHandler/GtmMHubHandler');
		case 'Execute':
			return import('./components/Execute');
		case 'TransformerTabs':
			return import('./components/TransformerTabs');
		case 'InputMaskComponent':
			return import('./components/InputMask');
		case 'ReviewSubmitter':
			return import('./components/ReviewSubmitter');
		case 'ModalWindow':
			return import('./components/ModalWindow');
		case 'KoopDatepicker':
			return import('./components/KoopDatepicker');
		case 'Submitter':
			return import('./components/Submitter');
		case 'PackageList':
			return import('./components/PackageList');
		case 'KoopForm':
			return import('./components/KoopForm');
		case 'VehicleTypeSelect':
			return import('./components/VehicleTypeSelect');
		case 'PrintPage':
			return import('./components/PrintPage');
		case 'PaymentLoader':
			return import('./components/PaymentLoader');
		case 'Preloader':
			return import('./components/preloader/Preloader');
		case 'AlertBox':
			return import('fg-frontend/src/components/AlertBox');
		case 'Callback':
			return import('./components/Callback');
		case 'WeWillCallYou':
			return import('./components/WeWillCallYou');
		case 'ScrollToTargetAfterLoad':
			return import('./components/ScrollToTargetAfterLoad');
		case 'InsuranceGroupWithModal':
			return import('./components/InsuranceGroupWithModal');
		case 'InsuranceGroupHider':
			return import('./components/InsuranceGroupHider');
		default:
			console.log(`Unknown component ${ props.decorator || props.is }`);
			return null;
	}
};



// WEBPACK FOOTER //
// ./fe/web-auto/src/js/configureWebComponents.js